module.exports = __webpack_public_path__ + "img/facetime-with-mavis.e0b2e04d.jpg";